const { SIMPLE, ASYNC } = require('../utils/redux-helpers');

module.exports = {
    SET_MAIN_APP_LOADING: SIMPLE,
    SET_SAFE_ZONE_TOP_PX: SIMPLE,
    SET_SAFE_ZONE_BOTTOM_PX: SIMPLE,
    SET_SCHOOL_SWITCHING_STATE: SIMPLE,
    UPDATE_ROLE_GROUP_FILTER: SIMPLE,
    UPDATE_DISCOVER_SORT_TYPE: SIMPLE,
    UPDATE_SURVEYS_MANAGEMENT_FILTER: SIMPLE,
    UPDATE_CONNECTIONS_FILTER: SIMPLE,
    UPDATE_APP_REVIEW_STATUS: ASYNC,
    SET_USER_REVIEW_STATUS: SIMPLE,
    FETCH_USER_REVIEW_AVAILABLE_STATUS: ASYNC,
    CHECK_USER_IP: ASYNC,
    UPDATE_CLASSMATE_DISCOVER_SEARCH_FILTER: SIMPLE,
    UPDATE_NOTIFY_SEARCH_FILTER: SIMPLE,
    UPDATE_SURVEY_SEARCH_FILTER: SIMPLE,
    SET_FIREBASE_TOKEN: SIMPLE,
    SET_IN_BACKGROUND: SIMPLE,
    SET_INTERESTS_SEARCH_TEXT: SIMPLE,
    SET_APP_MESSAGE: SIMPLE,
    CLEAR_APP_MESSAGE: SIMPLE,
    OPEN_NOTIFICATIONS: SIMPLE,
    CLOSE_NOTIFICATIONS: SIMPLE,
    OPEN_LOGOUT_DIALOG: SIMPLE,
    CLOSE_LOGOUT_DIALOG: SIMPLE,
    OPEN_MODAL: SIMPLE,
    CLOSE_MODAL: SIMPLE,
    SET_HISTORY_PATHNAME: SIMPLE,
    SET_HISTORY_PREVIOUS_PATHNAME: SIMPLE,
    REMEMBER_SCROLL: SIMPLE,
    RESTORE_SCROLL: SIMPLE,
    SHOULD_REFRESH_SEARCH: SIMPLE,
    CLEAR_VALUES_FOR_SCHOOL_SWITCH: SIMPLE,
    SET_REMOTE_DEBUG_MODE_KEY: SIMPLE,
    IS_DOWNTIME_MODE: SIMPLE,
    IS_FORCE_APP_UPGRADE_MODE: SIMPLE,
    SET_DISCOVER_NAVIGATION: SIMPLE,
    CLEAR_DISCOVER_NAVIGATION: SIMPLE,
    SET_GROUP_NAVIGATION: SIMPLE,
    CLEAR_GROUP_NAVIGATION: SIMPLE,
    SET_DEBUG: SIMPLE
};
